import styled, { createGlobalStyle } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
export const StyledContactUsForm = styled.div`
  .m-input-field {
    caret-color: auto;
  }
  h2 {
    max-width: 855pt;
    margin: 0 auto ${toRem(40)} auto;
    font-weight: bold;
  }
  select {
    white-space: normal;
    word-wrap: break-word;
  }
  &.contactus_wrapper {
    margin: ${toRem(60)} 0;
    @media screen and (max-width: ${toRem(576)}) {
      margin: ${toRem(40)} auto;
      max-width: 80%;
    }
  }
  div {
    &.contactus_container {
      background-color: ${baseVariables.color['base20']};
      max-width: 855pt;
      margin: 0 auto;
      box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
      border-radius: ${toRem(14)};
      padding: 0 ${toRem(98)};

      @media screen and (max-width: ${toRem(576)}) {
        padding: 0 0.5rem;
      }
      @media ${baseVariables.mediaQuery.sm} {
        max-width: ${toRem(540)};
      }
      @media ${baseVariables.mediaQuery.md} {
        max-width: 45pc;
      }
      @media ${baseVariables.mediaQuery.lg} {
        max-width: 60pc;
      }
      @media ${baseVariables.mediaQuery.xl} {
        max-width: 855pt;
      }

      .main-container {
        padding: ${toRem(28)} ${toRem(16)} ${toRem(32)};
        @media screen and (min-width: ${toRem(768)}) {
          padding: ${toRem(28)} ${toRem(16)} ${toRem(80)};
        }

        .topic-dropdown {
          width: 100%;
          margin-top: ${toRem(24)};
          @media ${baseVariables.mediaQuery.lg} {
            width: 40%;
          }
        }

        .btn-container {
          @media screen and (max-width: 992px) {
            margin-top: ${toRem(32)};
          }
          button {
            width: ${toRem(177)};
            @media screen and (max-width: ${toRem(768)}) {
              width: 100%;
              height: ${toRem(32)};
              &.sbt-btn {
                margin: ${toRem(4)} 0 ${toRem(16)} 0;
              }
            }
            &.disable-btn {
              background-color: #c4c4c4;
              cursor: no-drop;
            }
          }
        }
      }
    }
  }
`;

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: #f4f4f4 !important;
  }
`;
